import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import { Tooltip as MaterialTooltip } from "@material-ui/core";

import { StyledChildrenContainer } from "./styles";

const UnstyledHoverToOpen = ({ className, children, ...tooltipProps }) => {
    return (
        <MaterialTooltip className={className} {...tooltipProps}>
            <StyledChildrenContainer className={className}>
                {children}
            </StyledChildrenContainer>
        </MaterialTooltip>
    );
};

const HoverToOpen = styled(UnstyledHoverToOpen)``;

HoverToOpen.propTypes = {
    children: PropTypes.any.isRequired
};

export default HoverToOpen;
